import { Action } from "src/state/_types";

export const toggleUIViewMode: Action = async ({state}) => {
    state.ui.view = state.ui.view === 'list' ? 'cards' : 'list'
}